import React from 'react';
import clsx from 'clsx';

export default function PageHeader({ eyebrow, title, accent, description, align = 'left', children }) {
  return (
    <section className={clsx('relative section-pad pt-14 lg:pt-20 pb-10', align === 'center' && 'text-center')}>
      <div className="container-x">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl text-bone-50 mt-4 leading-[1.02] tracking-tight text-balance">
          {title} {accent && <span className="italic text-sage-300">{accent}</span>}
        </h1>
        {description && (
          <p className={clsx('text-bone-200/90 mt-6 max-w-2xl text-base lg:text-lg leading-relaxed', align === 'center' && 'mx-auto')}>
            {description}
          </p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
      <div className="absolute inset-x-0 -bottom-2 h-px divider-gold" />
    </section>
  );
}
